/* Agents & automations: tasks with plan mode, steering and approvals, the agent's computer, cloud and
   local browsers, desktop grants, schedules, workflows, always-on agents, phone calls, chat-app and
   email entry points, and sharing with replay. API: api/src/modules/{agents,automations,browser,sandbox}.
   The coding agent (AGENT-03, AGENT-10) lives on the `code` screen.
   Merged into Ask (features/ask): hidden here, /agents redirects into Ask, the screen in this folder is what Ask
   shows at /ask/agents, and Ask carries the approvals badge. */
import { lazy } from 'react';
import { Bot } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'agents',
  title: 'Agents & automations',
  short: 'Agents',
  icon: Bot,
  group: 'Work',
  route: '/agents',
  order: 30,
  hidden: true,
  screen: lazy(() => import('../ask/AskRedirect.tsx')),
  capabilities: [
    'AGENT-01', 'AGENT-02', 'AGENT-04', 'AGENT-05', 'AGENT-06', 'AGENT-07', 'AGENT-08', 'AGENT-09',
    'AGENT-11', 'AGENT-12', 'AGENT-13', 'AGENT-14', 'AGENT-15', 'AGENT-16', 'AGENT-17', 'AGENT-22', 'AGENT-23',
  ],
});
